import {ProductApi} from "@core/api";
import {fromCard} from "@core/domain/product/factory";
import store from "@/store"
import Vue from 'vue'

let requests = {};

store.watch(
    (state) => {
        return state.user.organization;
    },
    () => {
        requests = {};
    }
)

export function sentRequestProvider(id) {
    if (requests[id]) {
        return requests[id];
    }

    return requests[id] = new SentRequest(id);
}

export class SentRequest {
    id;
    request;
    requestPromise;
    product;

    constructor(id) {
        this.id = id;
    }

    getRequest() {
        if (this.requestPromise) {
            return this.requestPromise;
        }
        return this.requestPromise = new Promise((resolve, reject) => {
            ProductApi
                .getSentRequest(this.id)
                .then(r => {
                    this.request = Vue.observable(r.data);
                    this.product = fromCard(this.request.product);
                    resolve(this.request);
                })
                .catch(reject)
            ;
        });
    }

    getProduct() {
        return this
            .getRequest()
            .then(() => {
                return this.product;
            });
    }

    saveExternalResponse(response) {
        return ProductApi.saveExternalResponse(this.id, response);
    }
}
